<template>
  <div class="container-fluid d-flex justify-content-center">
    <div class="row portfolio-items">
      <!--PORTFOLIO ITEM 1 -->
      <div class="col-lg-4 offset-md-4 mb-5 mt-2">
        <div
          class="portfolio-item"
          data-bs-toggle="modal"
          data-bs-target="#portfolioModal1"
        >
          <img
            src="../../assets/sweetx-javaEE-project.png"
            class="d-block h-auto w-100"
          />
          <div class="overlay">
            <div class="text text-uppercase">Sweetx E-commerce Website</div>
          </div>
        </div>
      </div>

      <!--PORTFOLIO ITEM 2 -->
      <div class="col-lg-4 offset-md-4 mb-5 mt-5">
        <div
          class="portfolio-item"
          data-bs-toggle="modal"
          data-bs-target="#portfolioModal2"
        >
          <img
            src="../../assets/banco-de-nimbly.png"
            class="d-block h-auto w-100"
          />
          <div class="overlay">
            <div class="text text-uppercase">Banco De Nimbly</div>
          </div>
        </div>
      </div>

      <!--PORTFOLIO ITEM 3 -->
      <div class="col-lg-4 offset-md-4 mb-5 mt-5">
        <div
          class="portfolio-item"
          data-bs-toggle="modal"
          data-bs-target="#portfolioModal3"
        >
          <img
            src="../../assets/php-project.png"
            class="d-block h-auto w-100"
          />
          <div class="overlay">
            <div class="text text-uppercase">PHP made web application</div>
          </div>
        </div>
      </div>
    </div>
    <!--END DIV -->
  </div>
</template>

<script>
export default {
  name: "portfolio-body",
};
</script>

<style >
.portfolio-items {
  width: 100%;
  text-align: center;
}
img {
  opacity: 1;
  transition: 0.5s ease;
  backface-visibility: hidden;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: #008cba;
}
.text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
.portfolio-item {
  position: relative;
  max-width: auto;
  height: auto;
}
.portfolio-item:hover .overlay {
  opacity: 1;
}
</style>